import { GenericoTipoEnum } from "../../bibliotecaPjus/enums/enumGenerico.enum";

export enum Documento {
  Selfie = 'Selfie',
  RGFrente = 'RGFrente',
  RGVerso = 'RGVerso',
  CNH = 'CNH',
  Pagamento = 'Pagamento',
  Parecer = 'Parecer',
  FolhaDeCalculo = 'FolhaDeCalculo',
  RGFrenteConjuge = 'RGFrenteConjuge',
  RGVersoConjuge = 'RGVersoConjuge',
  CNHConjuge = 'CNHConjuge',
  Escritura = 'Escritura',
  CNDFederal1Grau = 'CNDFederal1Grau',
  CNDFederal2Grau = 'CNDFederal2Grau',
  CNDFederal = 'CNDFederal',
  FolhaDeCalculoPos = 'FolhaDeCalculoPos',
  Oficio = 'Oficio',
  ComprovanteEndereco = 'ComprovanteEndereco',
  CartaoCPF = 'CartaoCPF',
  CartaoCNPJ = 'CartaoCNPJ',
  CertidaojuntaComercial = 'CertidaojuntaComercial',
  ComprovanteDadosBancarios = 'ComprovanteDadosBancarios',
  CNDTrabalhista = 'CNDTrabalhista',
  NaoIdentificado = 'NaoIdentificado',
  ParecerAutomatico = 'ParecerAutomatico',
  CalculoN = 'CalculoN',
  ParecerTrabalhistaProvisorio = 'ParecerTrabalhistaProvisorio',
  CalculoPrevioTrabalhista = 'CalculoPrevioTrabalhista',
  Serasa = 'Serasa',
  ParecerTrabalhistaValidacaoCalculoParecer = 'ParecerTrabalhistaValidacaoCalculoParecer',
  CalculoProposta = 'CalculoProposta',
  ContratoSocial = 'ContratoSocial',
  CertidaoOab = 'CertidaoOab',
  ContratoHonorarios = 'ContratoHonorarios',
  CertidaoCasamento = 'CertidaoCasamento',
  CertidaoNascimento = 'CertidaoNascimento',
  AtestadoSanidade = 'AtestadoSanidade',
  DocumentoIdentificacao = 'DocumentoIdentificacao',
  CertidaoUniaoEstavel = 'CertidaoUniaoEstavel',
  CertidaoNaoUniaoEstavel = 'CertidaoNaoUniaoEstavel',
  CND = 'CND',
  CNAT = 'CNAT',
  CNDEstadual1Grau = 'CNDEstadual1Grau',
  CNDEstadual2Grau = 'CNDEstadual2Grau',
  CertidaoNascimentoCasamento = 'CertidaoNascimentoCasamento',
  DocumentoIdentificacaoConjuge = 'DocumentoIdentificacaoConjuge',
  CertidaoObito = 'CertidaoObito',
  AtestadoSanidadeConjuge = 'AtestadoSanidadeConjuge',
  ParecerTrabalhistaDefinitivo = 'ParecerTrabalhistaDefinitivo',
  Outros = 'Outros',
  PropostaParceiroNegociador = 'PropostaParceiroNegociador',
  PlanilhaDeCalculo = 'PlanilhaDeCalculo',
  CopiaPrecatorio = 'CopiaPrecatorio',
  OutrosDocumentosRelevantes = 'OutrosDocumentosRelevantes',
  OutrosDocumentos = 'OutrosDocumentos',
  DocumentosComprobatoriosPagamentoParcelaPreferencia = 'DocumentosComprobatoriosPagamentoParcelaPreferencia',
  EstadoCivil = 'EstadoCivil',
  CartaPropostaConcorrente = 'CartaPropostaConcorrente',
}

export class DocumentoEnum extends GenericoTipoEnum<Documento> {
  static readonly Selfie = new DocumentoEnum(Documento.Selfie, "Selfie");
  static readonly RGFrente = new DocumentoEnum(Documento.RGFrente, "RG Frente");
  static readonly RGVerso = new DocumentoEnum(Documento.RGVerso, "RG Verso");
  static readonly CNH = new DocumentoEnum(Documento.CNH, "CNH");
  static readonly Pagamento = new DocumentoEnum(Documento.Pagamento, "Pagamento");
  static readonly Parecer = new DocumentoEnum(Documento.Parecer, "Parecer");
  static readonly FolhaDeCalculo = new DocumentoEnum(Documento.FolhaDeCalculo, "Folha de Cálculo");
  static readonly RGFrenteConjuge = new DocumentoEnum(Documento.RGFrenteConjuge, "RG Frente Cônjuge");
  static readonly RGVersoConjuge = new DocumentoEnum(Documento.RGVersoConjuge, "RG Verso Cônjuge");
  static readonly CNHConjuge = new DocumentoEnum(Documento.CNHConjuge, "CNH Cônjuge");
  static readonly Escritura = new DocumentoEnum(Documento.Escritura, "Escritura");
  static readonly CNDFederal1Grau = new DocumentoEnum(Documento.CNDFederal1Grau, "CND Federal 1º Grau");
  static readonly CNDFederal2Grau = new DocumentoEnum(Documento.CNDFederal2Grau, "CND Federal 2º Grau");
  static readonly CNDFederal = new DocumentoEnum(Documento.CNDFederal, "CND Federal");
  static readonly FolhaDeCalculoPos = new DocumentoEnum(Documento.FolhaDeCalculoPos, "Folha de Cálculo Pós");
  static readonly Oficio = new DocumentoEnum(Documento.Oficio, "Ofício");
  static readonly ComprovanteEndereco = new DocumentoEnum(Documento.ComprovanteEndereco, "Comprovante de Endereço");
  static readonly CartaoCPF = new DocumentoEnum(Documento.CartaoCPF, "CPF");
  static readonly CartaoCNPJ = new DocumentoEnum(Documento.CartaoCNPJ, "Cartão CNPJ");
  static readonly CertidaojuntaComercial = new DocumentoEnum(Documento.CertidaojuntaComercial, "Certidão da Junta Comercial / Certidão Simplificada ou Certidão da OAB");
  static readonly ComprovanteDadosBancarios = new DocumentoEnum(Documento.ComprovanteDadosBancarios, "Comprovante de Dados Bancários");
  static readonly CNDTrabalhista = new DocumentoEnum(Documento.CNDTrabalhista, "CND Trabalhista");
  static readonly NaoIdentificado = new DocumentoEnum(Documento.NaoIdentificado, "Não Identificado");
  static readonly ParecerAutomatico = new DocumentoEnum(Documento.ParecerAutomatico, "Parecer Automático");
  static readonly CalculoN = new DocumentoEnum(Documento.CalculoN, "Cálculo N");
  static readonly ParecerTrabalhistaProvisorio = new DocumentoEnum(Documento.ParecerTrabalhistaProvisorio, "Parecer Trabalhista Provisório");
  static readonly CalculoPrevioTrabalhista = new DocumentoEnum(Documento.CalculoPrevioTrabalhista, "Cálculo Prévio Trabalhista");
  static readonly Serasa = new DocumentoEnum(Documento.Serasa, "Serasa");
  static readonly ParecerTrabalhistaValidacaoCalculoParecer = new DocumentoEnum(Documento.ParecerTrabalhistaValidacaoCalculoParecer, "Parecer Trabalhista Validação Cálculo Parecer");
  static readonly CalculoProposta = new DocumentoEnum(Documento.CalculoProposta, "Cálculo Proposta");
  static readonly ContratoSocial = new DocumentoEnum(Documento.ContratoSocial, "Contrato Social");
  static readonly CertidaoOab = new DocumentoEnum(Documento.CertidaoOab, "Certidão OAB");
  static readonly ContratoHonorarios = new DocumentoEnum(Documento.ContratoHonorarios, "Contrato de Honorários");
  static readonly CertidaoCasamento = new DocumentoEnum(Documento.CertidaoCasamento, "Certidão de Casamento");
  static readonly CertidaoNascimento = new DocumentoEnum(Documento.CertidaoNascimento, "Certidão de Nascimento");
  static readonly AtestadoSanidade = new DocumentoEnum(Documento.AtestadoSanidade, "Atestado de Sanidade");
  static readonly DocumentoIdentificacao = new DocumentoEnum(Documento.DocumentoIdentificacao, "Documento de Identificação");
  static readonly CertidaoUniaoEstavel = new DocumentoEnum(Documento.CertidaoUniaoEstavel, "Certidão de União Estável");
  static readonly CertidaoNaoUniaoEstavel = new DocumentoEnum(Documento.CertidaoNaoUniaoEstavel, "Certidão de Não União Estável");
  static readonly CND = new DocumentoEnum(Documento.CND, "CND");
  static readonly CNAT = new DocumentoEnum(Documento.CNAT, "CNAT");
  static readonly CNDEstadual1Grau = new DocumentoEnum(Documento.CNDEstadual1Grau, "CND Estadual 1º Grau");
  static readonly CNDEstadual2Grau = new DocumentoEnum(Documento.CNDEstadual2Grau, "CND Estadual 2º Grau");
  static readonly CertidaoNascimentoCasamento = new DocumentoEnum(Documento.CertidaoNascimentoCasamento, "Certidão de Nascimento/Casamento");
  static readonly DocumentoIdentificacaoConjuge = new DocumentoEnum(Documento.DocumentoIdentificacaoConjuge, "Documento de Identificação do Cônjuge");
  static readonly CertidaoObito = new DocumentoEnum(Documento.CertidaoObito, "Certidão de Óbito");
  static readonly AtestadoSanidadeConjuge = new DocumentoEnum(Documento.AtestadoSanidadeConjuge, "Atestado de Sanidade do Cônjuge");
  static readonly ParecerTrabalhistaDefinitivo = new DocumentoEnum(Documento.ParecerTrabalhistaDefinitivo, "Parecer Trabalhista Definitivo");
  static readonly Outros = new DocumentoEnum(Documento.Outros, "Outros");
  static readonly PropostaParceiroNegociador = new DocumentoEnum(Documento.PropostaParceiroNegociador, "Proposta Parceiro Negociador");
  static readonly PlanilhaDeCalculo = new DocumentoEnum(Documento.PlanilhaDeCalculo, "Planilha de cálculo");
  static readonly CopiaPrecatorio = new DocumentoEnum(Documento.CopiaPrecatorio, "Cópia do precatório");
  static readonly OutrosDocumentosRelevantes = new DocumentoEnum(Documento.OutrosDocumentosRelevantes, "Outros documentos relevantes");
  static readonly OutrosDocumentos = new DocumentoEnum(Documento.OutrosDocumentos, "Outros Documentos");
  static readonly EstadoCivil = new DocumentoEnum(Documento.EstadoCivil, "Documento estado civil");
  static readonly DocumentosComprobatoriosPagamentoParcelaPreferencia = new DocumentoEnum(Documento.DocumentosComprobatoriosPagamentoParcelaPreferencia, "Documentos comprobatórios do pagamento da parcela preferencia");
  static readonly CartaPropostaConcorrente = new DocumentoEnum(Documento.CartaPropostaConcorrente, "Carta Proposta do Concorrente");
}
